<template>
  <div class="patient_wrap" :class="{ modal_patient: props.mode }">
    <a-spin :spinning="loading">
      <div class="searchContainer" ref="searchRef">
        <div class="search-item">
          <a-input
            style="width: 200px"
            class="search-input"
            v-model:value="listQuery.ucPatientId"
            size="large"
            placeholder="患者ID"
            allowClear
            @input="inputFormat($event, 'ucPatientId', 3)"
            :maxLength="20"
          >
            <template #prefix>
              <SearchOutlined class="search_icon" />
            </template>
          </a-input>
        </div>
        <div class="search-item">
          <a-input
            style="width: 200px"
            class="search-input"
            v-model:value="listQuery.patientName"
            size="large"
            placeholder="患者姓名"
            allowClear
            :maxLength="20"
          >
            <template #prefix>
              <SearchOutlined class="search_icon" />
            </template>
          </a-input>
        </div>
        <div class="search-item">
          <a-input
            style="width: 200px"
            class="search-input"
            v-model:value="listQuery.patientPhone"
            size="large"
            placeholder="请输入患者手机号"
            allowClear
            @input="inputFormat($event, 'patientPhone', 3)"
            :maxLength="20"
          >
            <template #prefix>
              <SearchOutlined class="search_icon" />
            </template>
          </a-input>
        </div>
        <div class="search-item">
          <a-select
            size="large"
            v-model:value="listQuery.status"
            style="width: 200px"
            :options="patientStatusMap"
            placeholder="请选择认证状态"
            allowClear
          ></a-select>
        </div>
        <div class="search-item">
          <a-select
            size="large"
            v-model:value="listQuery.cancel"
            style="width: 200px"
            :options="followStatusMap"
            placeholder="请选择关注状态"
            allowClear
          ></a-select>
        </div>
        <div class="search-item">
          <a-select
            size="large"
            v-model:value="listQuery.activeFollowupStatus"
            style="width: 200px"
            :options="activeFollowupStatusMap"
            placeholder="请选择主动回访状态"
            allowClear
            @change="doSearch"
          ></a-select>
        </div>
        <div class="search-item">
          <a-range-picker
            size="large"
            v-model:value="listQuery.lastTouchTime"
            :placeholder="['上次触达开始时间', '上次触达结束时间']"
            format="YYYY-MM-DD"
            class="search-picker"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            :disabled-date="lastTouchDisabledDate"
            @calendar-change="onLastTouchCalendarChange"
            @change="onLastTouchChange"
          />
        </div>
        <div class="search-item">
          <a-select
            size="large"
            v-model:value="listQuery.prescriptionStatus"
            style="width: 200px"
            :options="prescriptionStatusMap"
            placeholder="请选择处方状态"
            allowClear
          ></a-select>
        </div>
        <div class="search-item">
          <a-select
            size="large"
            v-model:value="listQuery.recomBuyCnt"
            style="width: 200px"
            :options="recomBuyCntMap"
            placeholder="请选择购买频次"
            allowClear
          ></a-select>
        </div>
        <div class="search-item">
          <a-select
            size="large"
            v-model:value="listQuery.skuName"
            style="width: 200px"
            placeholder="请输入开具药品"
            allowClear
            show-search
            :filter-option="false"
            :options="skuOptions"
            :loading="skuLoading"
            :not-found-content="skuLoading ? undefined : '暂无数据'"
            @search="handleSkuSearch"
          ></a-select>
        </div>
        <div class="search-item">
          <a-range-picker
            size="large"
            v-model:value="listQuery.prescriptionPayTime"
            :placeholder="['购买开始时间', '购买结束时间']"
            format="YYYY-MM-DD"
            class="search-picker"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
          />
        </div>
        <div class="search-item">
          <a-range-picker
            size="large"
            v-model:value="listQuery.reserveTime"
            :placeholder="['复诊开始时间', '复诊结束时间']"
            allowClear
            :showTime="showTimeObj"
            format="YYYY-MM-DD"
            class="search-picker"
            valueFormat="YYYY-MM-DD"
            :ranges="rangePresets"
            dropdownClassName="creatTime"
            :disabledDate="reserveDisabledDate"
          />
        </div>
        <div class="search-item">
          <a-range-picker
            size="large"
            v-model:value="dateList"
            :placeholder="['注册开始时间', '注册结束时间']"
            format="YYYY-MM-DD"
            class="search-picker"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
          />
        </div>
        <div class="search-item">
          <span>近7天内主动回访：</span>
          <a-select
            size="large"
            v-model:value="listQuery.activeTouchCount"
            style="width: 200px"
            :options="activeFollowupCntMap"
            placeholder="请选择次数"
            allowClear
          ></a-select>
        </div>
        <div class="search-item">
          <a-checkbox v-model:checked="listQuery.patientType" v-if="mode !== 'doctor'">
            预建档用户
          </a-checkbox>
        </div>
        <div class="search-item">
          <a-button class="search-button" size="large" @click="resetQuery">重置</a-button>
        </div>
        <div class="search-item">
          <a-button class="search-button" size="large" type="primary" @click="doSearch">
            搜索
          </a-button>
        </div>
      </div>

      <div class="data_wrap" @click.capture="handleDisabledCheckboxClick">
        <div class="title-wrap">
          <slot name="title">
            <div class="title">全部患者</div>
          </slot>
          <div class="title-actions">
            <div
              class="btn-text"
              :class="{ 'btn-text-active': visitAction === 1 }"
              @click="handleRevisitToggle(true, 1)"
            >
              <CallbackActiveIcon />
              主动回访
            </div>
            <div
              v-if="isAdmin"
              class="btn-text"
              :class="{ 'btn-text-active': visitAction === 2 }"
              @click="handleRevisitToggle(true, 2)"
            >
              <AssignCallbackIcon />
              分配回访
            </div>
          </div>
          <div class="followup-legend">
            <div
              v-for="item in followupLegend"
              :key="item.label"
              class="followup-legend-item"
              :class="{
                'followup-legend-item-active': item.value === listQuery.activeFollowupStatus
              }"
              @click="switchFollowupStatus(item.value)"
            >
              <span class="followup-legend-color" :style="item.style">
                <CheckOutlined
                  :style="{ fontSize: '10px' }"
                  v-show="item.value === listQuery.activeFollowupStatus"
                />
              </span>
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>
        <div style="min-height: 200px">
          <a-table
            class="table"
            :pagination="pagination"
            :rowKey="getRowKey"
            :columns="columns"
            :data-source="tableData"
            :row-selection="selectMode ? rowSelection : null"
            :customRow="customRow"
            @change="onChangePage"
            :scroll="{
              x: `calc(100% - 40px)`,
              y: isInModal ? '40vh' : `calc(100vh - ${sHeight}px)`
            }"
            :transformCellText="({ text }) => text ?? '--'"
          >
            <template #patientName="{ record }">
              <a-tooltip
                placement="bottomLeft"
                v-if="record.blackFlag"
                :title="`被医生拉黑名单，日期：${record.blackTime}`"
              >
                <span @click="handlePatientFile(record)" class="action-trigger">
                  {{ record.patientName }}
                  <QuestionCircleOutlined :style="{ color: '#999', marginLeft: '6px' }" />
                </span>
              </a-tooltip>
              <span
                v-else-if="record.patientPhone"
                @click="handlePatientFile(record)"
                class="action-trigger"
              >
                {{ record.patientName }}
              </span>
              <span v-else>--</span>
            </template>
            <template #patientPhone="{ record }">
              <span v-if="record.patientPhone">
                {{ record.patientPhone }}
                <auth-img :src="see_detail" @click="seeInfo(record)" class="see_detail" />
              </span>
              <span v-else>--</span>
            </template>
            <template #activeReachTime="{ record }">
              <a-tooltip
                v-if="record.activeReachTime"
                :overlayStyle="{ maxWidth: '520px' }"
                overlayClassName="patient-cdr-tooltip"
              >
                <template
                  #title
                  v-if="
                    Array.isArray(record.recentActiveTouches) && record.recentActiveTouches.length
                  "
                >
                  <div class="cdr-wrap">
                    <div>近3次主动触达:</div>
                    <div
                      v-for="item in record.recentActiveTouches"
                      :key="item.callCdrId"
                      class="cdr-item"
                    >
                      <div class="cdr-item-left">
                        <span>{{ item.touchAt }}</span>
                        <span class="cdr-item-job">健管</span>
                        <span class="cdr-item-name">{{ item.daName }}</span>
                      </div>
                      <div :class="{ 'cdr-item-status-error': item.touchStatus === 1 }">
                        {{ item.touchStatusName }}
                      </div>
                    </div>
                  </div>
                </template>
                <span>
                  {{ record.activeReachTime }}
                  <QuestionCircleFilled :style="{ color: '#ccc', marginLeft: '6px' }" />
                </span>
              </a-tooltip>
              <span v-else>--</span>
            </template>
            <template #lastActiveTouchAt="{ record }">
              <span
                v-if="record.lastActiveTouchAt"
                class="action-trigger"
                @click="handleShowSummary(record)"
              >
                <span>{{ record.lastActiveTouchAt }} {{ record.lastTouchWorkOrderType }}</span>
                <img
                  v-if="record.chatSummaryId"
                  class="action-trigger-icon"
                  src="https://file.drstrong.cn/frontend/fed-doctor-helper-ms/call.png"
                  alt=""
                />
              </span>
              <span v-else>--</span>
            </template>
            <template #activeFollowupStatusName="{ record }">
              <div class="daNameBlock">
                <a-tooltip :title="record.activeFollowupDaName">
                  <div class="da-names">
                    <span>{{ record.activeFollowupStatusName }}</span>
                    <span v-if="record.activeFollowupDaName">
                      -{{ record.activeFollowupDaName }}
                    </span>
                  </div>
                </a-tooltip>
                <a-tooltip
                  v-if="record.nextFollowupAt"
                  :overlayStyle="{ minWidth: '350px' }"
                  overlayClassName="patient-cdr-tooltip"
                  placement="top"
                  :title="`下次回访时间：${moment(record.nextFollowupAt).format(
                    'YYYY-MM-DD'
                  )}  健管-${record.daName}`"
                >
                  <QuestionCircleFilled
                    class="icon"
                    :style="{ color: '#ccc', marginLeft: '6px' }"
                  />
                </a-tooltip>
              </div>
            </template>
            <template #statusStr="{ record }">
              <!-- 认证状态 -->
              <the-tag v-if="record.statusStr" :color="patientStatusMap[record.status].color">
                {{ record.statusStr }}
              </the-tag>
              <span v-else>--</span>
            </template>
            <template #cancelStr="{ record }">
              <!-- 关注状态 -->
              <the-status v-if="record.cancelStr" :color="followStatusMap[record.cancel].color">
                {{ record.cancelStr }}
              </the-status>
              <span v-else>--</span>
            </template>
            <template #boundDoctorNum="{ record }">
              <!-- 绑定医生人数 -->
              <span class="link_content" @click="goPatientBindDoct(record)">
                {{ record.boundDoctorNum }}
              </span>
            </template>
            <template #operate="{ record }">
              <a-button
                v-if="record.patientType === 1"
                size="small"
                type="link"
                @click="onSendSMS(record)"
              >
                发送短信
              </a-button>
              <a-button size="small" type="link" @click="handleShowCommunication(record)">
                通话记录
              </a-button>
            </template>
          </a-table>
        </div>
        <div class="revisit_action_wrap" v-if="visitAction">
          <span>
            已选
            <span class="select_count">{{ selectedRowKeys.length }}</span>
            人
          </span>
          <a-button @click="handleRevisitToggle(false)">取消</a-button>
          <a-button
            type="primary"
            :disabled="selectedRowKeys.length === 0"
            :loading="submitLoading"
            @click="handleSubmit"
          >
            提交
          </a-button>
        </div>
      </div>
    </a-spin>
    <Details ref="detailsRef" />
    <RevisitConfirm ref="revisitConfirmRef" :userId="userId" @confirm="handleSubmitCallback" />
    <UserInfo ref="userInfoRef" />
    <SendSMS ref="sms"></SendSMS>
    <CommunicationModal ref="communicationModal" />
    <a-modal
      title="沟通小结"
      :visible="summaryPanelVisible"
      @cancel="summaryPanelVisible = false"
      width="1059px"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
      :bodyStyle="{
        padding: 0,
        paddingTop: '20px'
      }"
      :scroll="{ y: 300 }"
    >
      <SummaryPannel
        :chatSummaryId="chatSummaryId"
        @closeSummaryModal="summaryPanelVisible.value = false"
        :active="summaryActive"
      />
    </a-modal>
    <FloatingCallButton />
  </div>
</template>
<script>
export default { name: 'patient' }
</script>
<script setup>
import {
  reactive,
  ref,
  onMounted,
  nextTick,
  defineProps,
  watch,
  defineEmits,
  defineExpose,
  computed,
  h
} from 'vue'
import {
  paginationConfig,
  columns,
  followStatusMap,
  patientStatusMap,
  prescriptionStatusMap,
  recomBuyCntMap,
  activeFollowupCntMap,
  activeFollowupStatusMap,
  followupLegend,
  ROW_FOLLOWUP_BG
} from './config'
import { inputRule } from '@/utils/validate'
import { formatDateForFilter } from '@/utils'
import Details from '@/views/UserPool/components/Details'
import RevisitConfirm from '@/views/UserPool/components/RevisitConfirm.vue'
import CallbackActiveIcon from '@/assets/svg/CallbackActiveIcon.vue'
import AssignCallbackIcon from '@/assets/svg/AssignCallbackIcon.vue'
import { Checkbox, Tooltip, message } from 'ant-design-vue'
import { getPatientList, searchDrugOptions } from '@/api/UserPool'
import moment from 'moment'
import see_detail from '@/assets/img/see_detail.png'
import UserInfo from '@/views/UserPool/components/UserInfo'
import { useRoute } from 'vue-router'
import SendSMS from '@/components/SendSMS/index.vue'
import { QuestionCircleFilled, QuestionCircleOutlined, SearchOutlined } from '@ant-design/icons-vue'
import { rangePresets } from './options'
import { useStore } from 'vuex'
import { useFilterCache } from '@/hooks/useFilterCache'
import { FILTER_CACHE_PAGE_KEYS } from '@/constants/filterCache'
import { cloneDeep, debounce } from 'lodash-es'
import { SummaryPannel } from '@/views/WorkPlace/Container/chat/components'
import CommunicationModal from '@/components/CommunicationModal'
import { useSummary } from '@/hooks/useSummary'
import { CheckOutlined } from '@ant-design/icons-vue'
import FloatingCallButton from '@/views/UserPool/components/FloatingCallButton.vue'

const route = useRoute()

const props = defineProps({
  params: {
    type: Object,
    default: () => {}
  },
  mode: {
    type: String,
    default: ''
  },
  // 20260-1-9 领导说页面进来的时候不要查询
  // 是否立即发起请求
  immediately: {
    type: Boolean,
    default: false
  },
  isInModal: {
    type: Boolean,
    default: false
  }
})
const emits = defineEmits(['patientBindDoct', 'seeInfo'])
const store = useStore()
const isAdmin = computed(() => store.state.user.isAdmin)
const userId = computed(() => store.state.user.userId)
const searchRef = ref(null)
const detailsRef = ref(null)
const userInfoRef = ref(null)
const initDateList = []
const dateList = ref([...initDateList])
const loading = ref(false)
const defaultQuery = {
  ucPatientId: null, // 患者id
  patientName: '', // 患者姓名
  startTime: null, // 注册开始时间
  endTime: null, // 注册结束时间
  status: null, // 认证状态
  cancel: null, // 关注状态
  patientPhone: null, // 患者手机号
  recomBuyCnt: null, // 购买频次
  prescriptionStatus: null, // 处方状态
  skuName: null, // 开具药品
  lastTouchTime: null, // 上次触达时间
  prescriptionPayTime: null, // 购买时间
  reserveTime: null, // 复诊时间
  patientType: null, // 预建档用户
  lastTouchStartTime: null, // 上次触达开始时间
  lastTouchEndTime: null, // 上次触达时间
  prescriptionPayStartTime: null, // 购买开始时间
  prescriptionPayEndTime: null, // 购买结束时间
  activeFollowupStatus: null, // 主动回访状态
  activeTouchCount: null, // 主动回访次数
  sortField: null, // 排序字段
  sortOrder: null // 排序顺序
}
const listQuery = reactive({ ...defaultQuery })
const pagination = reactive({ ...paginationConfig })
const cacheEnabled = computed(() => !props.mode)
const defaultCacheQuery = {
  ...defaultQuery,
  dateList: [...initDateList],
  current: paginationConfig.current,
  pageSize: paginationConfig.pageSize
}
const { updateCache } = useFilterCache({
  pageKey: FILTER_CACHE_PAGE_KEYS.PATIENT_POOL_LIST,
  userId: computed(() => store.state.user.userId),
  defaultParams: defaultCacheQuery,
  normalize: params => ({
    ...cloneDeep(defaultCacheQuery),
    ...cloneDeep(params),
    dateList: Array.isArray(params?.dateList) ? params.dateList : [...initDateList],
    prescriptionPayTime: Array.isArray(params?.prescriptionPayTime)
      ? params.prescriptionPayTime
      : null,
    reserveTime: Array.isArray(params?.reserveTime) ? params.reserveTime : null,
    lastTouchTime: Array.isArray(params?.lastTouchTime) ? params.lastTouchTime : null
  })
})

const persistCache = () => {
  if (!cacheEnabled.value) return
  updateCache({
    ...listQuery,
    dateList: dateList.value,
    current: pagination.current,
    pageSize: pagination.pageSize
  })
}

const handleParams = (val = {}) => {
  Object.assign(listQuery, defaultQuery)
  Object.assign(pagination, paginationConfig)
  if (props.mode === 'doctor') {
    listQuery.doctorId = val.doctorId
    listQuery.bdId = null
    dateList.value = []
  }
  if (props.mode === 'bd' || props.mode === 'bdBindPatient') {
    listQuery.bdId = val.bdId || val.hid
    listQuery.doctorId = null
    dateList.value = []
  }
  searchList()
}
watch(
  () => props.params,
  val => {
    if (val === undefined) return
    handleParams(val)
  },
  {
    immediate: true,
    deep: true
  }
)
const tableData = ref([])
const sHeight = ref(60)
function resetQuery() {
  Object.assign(listQuery, defaultQuery)
  dateList.value = initDateList
  pagination.current = paginationConfig.current
  pagination.pageSize = paginationConfig.pageSize
  if (props.mode) {
    dateList.value = []
  }
  persistCache()
  searchList()
}
const showTimeObj = reactive({
  format: 'HH:mm:ss',
  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
})
const reserveDisabledDate = current => {
  return current && current < moment('2024-1-1 00:00:00')
}
function doSearch() {
  pagination.current = paginationConfig.current
  pagination.pageSize = paginationConfig.pageSize
  persistCache()
  searchList()
}
function searchList() {
  loading.value = true
  const [startTime, endTime] = formatDateForFilter(dateList.value)
  const params = {
    ...listQuery,
    pageNo: pagination.current,
    pageSize: pagination.pageSize,
    startTime,
    endTime,
    patientType: listQuery.patientType ? 0 : null,
    ...route.query
  }
  // 日期范围字段映射：源字段 -> [起始字段, 结束字段]
  const dateRangeMap = [
    ['reserveTime', 'reserveStartTime', 'reserveEndTime'],
    ['prescriptionPayTime', 'prescriptionPayStartTime', 'prescriptionPayEndTime'],
    ['lastTouchTime', 'lastTouchStartTime', 'lastTouchEndTime']
  ]
  // 将筛选表单中的日期范围字段拆分为起止时间字段，并删除原字段
  dateRangeMap.forEach(([source, startKey, endKey]) => {
    if (!params[source]) return
    const [start, end] = formatDateForFilter(params[source])
    params[startKey] = start
    params[endKey] = end
    delete params[source]
  })
  getPatientList(params)
    .then(res => {
      const { list = [], totalCount } = res
      tableData.value = list
      pagination.total = totalCount
      pagination.showTotal = () => `共${totalCount}条`
    })
    .catch(() => {
      tableData.value = []
    })
    .finally(() => {
      loading.value = false
    })
}

// 查看患者信息
const handlePatientFile = record => {
  const { patientId, doctorId, patientType } = record
  const param = {
    patientId: patientId,
    patientType: patientType,
    doctorId: doctorId
  }
  store.dispatch('patientFile/openModal', param)
}

const disabledDate = current => {
  return !(current && current < moment().endOf('day'))
}

// 上次触达时间限制一年跨度
const lastTouchPickDates = ref([])
const onLastTouchCalendarChange = dates => {
  lastTouchPickDates.value = dates || []
}
const onLastTouchChange = () => {
  lastTouchPickDates.value = []
}
const lastTouchDisabledDate = current => {
  // 不可选未来日期
  if (!current || current >= moment().endOf('day')) {
    return true
  }
  const [start] = lastTouchPickDates.value
  if (!start) {
    return false
  }
  // 限制时间跨度不超过一年
  const tooLate = current > moment(start).add(1, 'years')
  const tooEarly = current < moment(start).subtract(1, 'years')
  return tooLate || tooEarly
}
function inputFormat(e, key, type) {
  listQuery[key] = inputRule(e.target.value, type)
}
// 开具药品下拉：远程搜索（默认无数据，输入关键字后才请求；接口见 searchDrugOptions）
const skuOptions = ref([])
const skuLoading = ref(false)
async function fetchSkuOptions(keyword = '') {
  skuLoading.value = true
  try {
    const list = await searchDrugOptions({ skuName: keyword })
    skuOptions.value = Array.isArray(list)
      ? list.map(it => ({
          value: it,
          label: it
        }))
      : []
  } catch (error) {
    skuOptions.value = []
  } finally {
    skuLoading.value = false
  }
}
const handleSkuSearch = debounce(keyword => {
  const kw = (keyword || '').trim()
  // 默认无下拉数据，输入关键字后才走远程搜索
  if (!kw) {
    skuOptions.value = []
    return
  }
  fetchSkuOptions(kw)
}, 300)
const onChangePage = (page, _, sorter) => {
  pagination.current = page.current
  pagination.pageSize = page.pageSize
  listQuery.sortField = sorter.order ? sorter.field : null
  listQuery.sortOrder = sorter.order ? (sorter.order === 'ascend' ? 'asc' : 'desc') : null
  persistCache()
  searchList()
}
const goPatientBindDoct = row => {
  const { boundDoctorNum } = row
  if (!boundDoctorNum) return
  if (props.mode) {
    emits('patientBindDoct', row)
  } else {
    row.mode = 'patient'
    detailsRef?.value?.initModal(row)
  }
}
const seeInfo = record => {
  const { patientId, patientType } = record
  const type = patientType === 1 ? patientType : -1
  // 医生下钻患者池为一对一医患关系，带上该医生的 ucDoctorId（BD 下钻无医生，传 undefined）
  const ucDoctorId = props.mode === 'doctor' ? props?.params?.ucDoctorId : undefined
  const params = {
    accountType: type,
    id: patientId,
    ucDoctorId
  }
  if (props.mode) {
    emits('seeInfo', patientId, type, ucDoctorId)
  } else {
    userInfoRef?.value.initModal(params)
  }
}
const getHeight = () => {
  nextTick(() => {
    sHeight.value = (searchRef?.value?.clientHeight || 160) + 300
  })
}
const sms = ref()
function onSendSMS(record) {
  const { ucPatientId, ucDoctorId, patientName } = record
  const pInfo = {
    id: ucPatientId,
    name: patientName
  }
  const dInfo = {
    id: ucDoctorId
  }
  sms.value.open(1, pInfo, dInfo)
}

// 通话记录
const communicationModal = ref()
function handleShowCommunication(record) {
  communicationModal.value.openModal(record)
}

// ===== 多选功能（常态隐藏，外部调用开启） =====
const selectMode = ref(false)
const selectedRowKeys = ref([])
const selectedRows = ref([]) //选中的每行

// 行唯一 key：ucPatientId + prePatientId（预建档患者 ucPatientId 可能为空，需组合才唯一）
// 表格 rowKey 与 selectedRowKeys 必须共用该函数，否则选中态与行数据对不上
const getRowKey = record => `${record?.ucPatientId ?? ''}-${record?.prePatientId ?? ''}`
// 0-未选择 1-主动回访 2: 分配回访
const visitAction = ref(0)
const submitLoading = ref(false)
const revisitConfirmRef = ref(null)

const isStandalone = computed(() => !props.mode || props.mode === 'bdBindPatient')

const updateRows = () => {
  // 以 selectedRowKeys 为准同步选中行数据：先按 rowKey 去重保证唯一，再剔除已取消勾选的行
  const keySet = new Set(selectedRowKeys.value)
  const unique = [...new Map(selectedRows.value.map(row => [getRowKey(row), row])).values()]
  selectedRows.value = unique.filter(row => keySet.has(getRowKey(row)))
}
// 选择列头：全选 + 提示图标（仅患者池列表独立场景）
const renderSelectionHeader = () => {
  const selectableRows = tableData.value.filter(row => row.boundDoctorNum === 1)
  const selectableKeys = selectableRows.map(getRowKey)
  const selectableKeySet = new Set(selectableKeys)

  const selectedCount = selectableKeys.filter(key => new Set(selectedRowKeys.value).has(key)).length
  const allChecked = selectableKeys.length > 0 && selectedCount === selectableKeys.length
  const indeterminate = selectedCount > 0 && !allChecked

  const handleSelectAll = e => {
    if (e.target.checked) {
      selectedRowKeys.value = Array.from(new Set([...selectedRowKeys.value, ...selectableKeys]))
      selectedRows.value = selectedRows.value.concat(selectableRows)
    } else {
      selectedRowKeys.value = selectedRowKeys.value.filter(key => !selectableKeySet.has(key))
    }
    updateRows()
  }

  return h(
    'span',
    { style: { display: 'inline-flex', alignItems: 'center', gap: '6px' } },
    '全选',
    [
      h(
        Tooltip,
        {
          title:
            '仅绑定单个医生的患者可批量勾选；若患者绑定多个医生，需前往患者档案，选择对应医生后逐一添加。'
        },
        {
          default: () => h(QuestionCircleFilled, { style: { color: '#ccc', fontSize: '14px' } })
        }
      ),
      h(Checkbox, {
        checked: allChecked,
        indeterminate,
        disabled: selectableKeys.length === 0,
        onChange: handleSelectAll
      })
    ]
  )
}

const rowSelection = computed(() => {
  const selection = {
    columnWidth: 150,
    fixed: true,
    selectedRowKeys: selectedRowKeys.value,
    // 跨页保留选中：否则翻页后 onChange 只会返回当前页的 key，之前选中的患者会被清掉
    preserveSelectedRowKeys: true,
    onChange: (keys, _rows) => {
      selectedRowKeys.value = Array.from(new Set(keys))
      selectedRows.value = selectedRows.value.concat(_rows)
      updateRows()
    }
  }
  // 仅患者池列表（独立场景）限制：仅绑定单个医生的患者可批量勾选
  if (isStandalone.value) {
    selection.getCheckboxProps = record => ({ disabled: record.boundDoctorNum !== 1 })
    selection.columnTitle = renderSelectionHeader
  }
  return selection
})

// 单元格内可点击元素：点击这些元素时不触发整行选中
const INTERACTIVE_CELL_SELECTOR =
  '.ant-checkbox-wrapper, button, a, .action-trigger, .see_detail, .link_content'

// 该行是否可勾选（独立患者池场景下仅绑定单个医生的患者可勾选）
const isSelectableRow = record => !isStandalone.value || record.boundDoctorNum === 1

// 不可勾选原因提示
const warnRowNotSelectable = row => {
  if (row.boundDoctorNum > 1) {
    message.warn('暂不支持批量操作，所选患者归属不同医生，请单独处理。')
  } else if (row.boundDoctorNum === 0) {
    message.warn('所选患者未绑定医生，暂不支持批量操作，前往患者档案进行分配。')
  }
}

// 可选模式下点击整行切换选中
const toggleRowSelection = record => {
  if (!isSelectableRow(record)) {
    warnRowNotSelectable(record)
    return
  }
  const key = getRowKey(record)
  const keys = selectedRowKeys.value.slice()
  const idx = keys.indexOf(key)
  if (idx >= 0) {
    keys.splice(idx, 1)
  } else {
    keys.push(key)
  }
  selectedRowKeys.value = keys
  selectedRows.value.push(record)
  updateRows()
}

const getRowFollowupBg = record => {
  if (record.nextFollowupAt) return ROW_FOLLOWUP_BG.followupSet
  if (record.activeFollowupStatus === 1) return ROW_FOLLOWUP_BG.inPool
  return ROW_FOLLOWUP_BG.notInPool
}

const customRow = record => ({
  style: { background: getRowFollowupBg(record) },
  onClick: e => {
    if (!selectMode.value) return
    const target = e.target
    if (target instanceof Element && target.closest(INTERACTIVE_CELL_SELECTOR)) return
    toggleRowSelection(record)
  }
})

const handleRevisitToggle = (isActive, key) => {
  visitAction.value = isActive ? key : ''
  if (isActive) {
    enableSelect()
  } else {
    disableSelect()
  }
}

const handleSubmit = async () => {
  // 以 selectedRowKeys 为准，从 selectedRows 里过滤出真正选中的行，保证一一对应且去重
  const rowMap = new Map(selectedRows.value.map(row => [getRowKey(row), row]))
  const keys = Array.from(new Set(selectedRowKeys.value))
  const rows = keys
    .map(key => rowMap.get(key))
    // 剔除无患者ID 及不可批量操作的行
    .filter(row => row && row.ucPatientId && isSelectableRow(row))
  if (!rows.length) {
    message.warn('暂无可提交的患者，请重新选择')
    return
  }
  submitLoading.value = true
  try {
    const pairs = rows.map(row => {
      return {
        ucPatientId: row.ucPatientId,
        ucDoctorId: props.mode === 'doctor' ? props?.params?.ucDoctorId || 0 : row?.ucDoctorId ?? 0
      }
    })
    await revisitConfirmRef.value?.initModal({
      visitAction: visitAction.value,
      patientDoctorPairs: pairs
    })
  } finally {
    submitLoading.value = false
  }
}

const handleSubmitCallback = () => {
  clearSelection()
  searchList()
}

// 点击被禁用的勾选框时，根据禁用原因弹 Toast（仅患者池列表独立场景）
const handleDisabledCheckboxClick = e => {
  if (!selectMode.value || props.mode || props.mode !== 'bdBindPatient') return
  const target = e.target
  if (!(target instanceof Element)) return
  const disabledCheckbox = target.closest('.ant-checkbox-wrapper-disabled')
  if (!disabledCheckbox) return
  const tr = target.closest('tr[data-row-key]')
  if (!tr) return
  const rowKey = tr.getAttribute('data-row-key')
  const row = tableData.value.find(r => getRowKey(r) === rowKey)
  if (!row) return
  warnRowNotSelectable(row)
}

function enableSelect() {
  selectMode.value = true
}

// 清空选中
function clearSelection() {
  selectedRowKeys.value = []
  selectedRows.value = []
}

// 关闭多选并清空选中
function disableSelect() {
  selectMode.value = false
  clearSelection()
}

// 展示沟通小结
const {
  summaryActive,
  chatSummaryId,
  summaryPanelVisible: summaryPanelVisible
} = useSummary(searchList)
const handleShowSummary = record => {
  if (!record.chatSummaryId) {
    // handleShowCommunication(record)
    const form = {
      // ucPatientId,
      // prePatientId,
      // patientType,
      // cdrId,
      ...record,
      showSearch: false
    }
    communicationModal.value.openModal(form)
  } else {
    chatSummaryId.value = record.chatSummaryId
    summaryPanelVisible.value = true
    summaryActive.value = 2
  }
}
//
const switchFollowupStatus = key => {
  listQuery.activeFollowupStatus = key
  doSearch()
}
defineExpose({ enableSelect, disableSelect, clearSelection, handleRevisitToggle })

onMounted(() => {
  getHeight()
})
</script>
<style scoped lang="scss">
@import './table-style.scss';

.patient_wrap {
  height: 100%;
  &.modal_patient {
    .searchContainer {
      padding: initial;
      margin-bottom: 14px;
    }
    .data_wrap {
      margin: initial;
      padding: initial;
    }
  }
}
.searchContainer {
  background-color: #fff;
  padding: 10px 20px 0;
  .search-item {
    display: inline-block;
    margin-bottom: 10px;
    margin-right: 12px;
    .search_icon {
      color: rgba(0, 0, 0, 0.45);
    }
  }
}
.data_wrap {
  margin: 20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  position: relative;

  .title {
    font-weight: 400;
    font-size: 14px;
    color: #000000e0;
  }
  .see_detail {
    width: 16px;
    height: 16px;
    margin-left: 4px;
    cursor: pointer;
  }
}
// 禁用勾选框可点击：disabled input 会吞掉点击事件，穿透后由 handleDisabledCheckboxClick 捕获弹 Toast
.data_wrap :deep(.ant-checkbox-wrapper-disabled .ant-checkbox-input) {
  pointer-events: none;
}

.title-wrap {
  margin-bottom: 17px;
  display: flex;
  align-items: center;
  .title-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: 10px;
  }

  .btn-text {
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 500;
    padding: 6px 12px;
    border-radius: 4px;
    border: 1px solid var(--el-color-info-light-7);
    background: var(--el-fill-color-lighter);
    color: var(--el-text-color-primary);
    cursor: pointer;
  }

  .btn-text-active {
    border: 1px solid var(--el-color-primary);
    background: var(--el-color-primary-light-9);
    color: var(--el-color-primary);
  }

  .followup-legend {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-left: auto;
  }

  .followup-legend-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #00000099;
    cursor: pointer;
  }

  .followup-legend-color {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.revisit_action_wrap {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  font-size: 16px;
  color: #333;
  // margin-top: 10px;
  width: fit-content;
  position: absolute;
  right: 30px;
  bottom: 20px;
  .select_count {
    font-weight: 500;
    color: #111;
  }
}

.action-trigger {
  color: #1890ff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.action-trigger-icon {
  width: 16px;
}
.cdr-wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.cdr-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 330px;
}

.cdr-item-left {
  display: flex;
  align-items: center;
  width: 280px;
}

.cdr-item-job {
  padding: 2px 6px;
  font-size: 12px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.2);
  margin: 0 6px 0 14px;
}

.cdr-item-name {
  width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.daNameBlock {
  display: flex;
  align-items: center;
  .da-names {
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.cdr-item-status-error {
  color: #f5222d;
}
</style>
<style lang="scss">
.patient-cdr-tooltip {
  .ant-tooltip-inner {
    border-radius: 8px;
    padding: 12px;
  }
}
</style>
